import React, { Component } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 23px 0 20px 0;
`;

class LocateMeButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: null,
      lng: null,
      running: false
    };
  }

  getInitialState = () => {
    return {
      running: ""
    };
  };

  changeFilter = value => {
    this.setState({
      filter: value
    });
  };

  position = async () => {
    this.setState({
      running: "running"
    });

    await navigator.geolocation.getCurrentPosition(
      position =>
        this.setState(
          {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            running: ""
          },
          newState => this.props.updateLocation(this.state.lat, this.state.lng)
        ),
      err => console.log(err)
    );
  };

  render() {
    // console.log(this.getInitialState());
    const isRunning = this.state.running;
    const classes =
      "button yellow-button locate-me-button ld-ext-right " + isRunning;
    return (
      <Wrapper>
        <div className={classes} onClick={this.position}>
          {this.props.label}
          <div className="ld ld-ring ld-spin" />
        </div>
      </Wrapper>
    );
  }
}

export default LocateMeButton;
